import { ButtonGroup, useRadioGroup } from "@chakra-ui/react";
import CustomRadioButton from "../CustomRadioButton";

interface ClaimTypesProps {
  radioButtons: Array<{ label: string; value: string }>;
  onRadioChange: (key: string) => void;
}

const ClaimTypes = ({ radioButtons, onRadioChange }: ClaimTypesProps) => {
  const { getRootProps, getRadioProps } = useRadioGroup({
    name: "withdrawModes",
    defaultValue: radioButtons[0].value,
    onChange: onRadioChange,
  });

  const group = getRootProps();
  return (
    <ButtonGroup {...group} isAttached mb={{ base: "1.5rem", md: "2rem" }}>
      {radioButtons.map((radioButton, index) => (
        <CustomRadioButton
          key={radioButton.label}
          {...getRadioProps({ value: radioButton.value })}
          label={radioButton.label}
          index={index}
        />
      ))}
    </ButtonGroup>
  );
};

export default ClaimTypes;
